import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { FUTURE_TOKENS } from '../../constants/futureTokens.js';
import { spacing2x, spacing4x } from '../../styles/spacing.js';
import { getColorWithOpacity } from '../../utils/color.js';
import { isEmpty } from '../../utils/lang.js';
import { ButtonMenu } from '../ButtonMenu/ButtonMenu.js';
import { CardContainer } from '../CardBase/CardContainer.js';
import { CardTitle } from '../CardBase/CardTitle.js';
import { Checkbox } from '../Checkbox/Checkbox.js';
import { IconMore } from '../Icons/IconMore.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["actions", "buttonMenuProps", "checkboxProps", "titleProps"];
var CardActions = styled.div.withConfig({
  displayName: "FolderCard__CardActions",
  componentId: "sc-d0dy3l-0"
})(["&&{display:flex;opacity:0;align-items:center;justify-content:center;position:absolute;padding-inline-start:", ";inset-inline-end:", ";background:", ";}&& > div{align-items:center;display:flex;justify-content:center;min-height:32px;min-width:32px;}"], spacing2x, spacing2x, FUTURE_TOKENS.FOLDER_CARD_ACTIONS_BACKGROUND_COLOR);
var StyledCardContainer = styled(CardContainer).withConfig({
  displayName: "FolderCard__StyledCardContainer",
  componentId: "sc-d0dy3l-1"
})(["&&{position:relative;display:flex;height:52px;max-width:216px;align-items:center;padding-inline:", ";background:", ";}&&:hover ", ",&&:focus ", ",&&:focus-within ", "{", ";opacity:1;}"], spacing4x, function (_ref) {
  var selected = _ref.selected,
    theme = _ref.theme;
  return selected ? getColorWithOpacity(theme.CTAColors.primary, 0.1) : theme.neutralColors.white;
}, CardActions, CardActions, CardActions, function (_ref2) {
  var selected = _ref2.selected;
  return selected && "display: none;";
});
var StyledCheckbox = styled(Checkbox).withConfig({
  displayName: "FolderCard__StyledCheckbox",
  componentId: "sc-d0dy3l-2"
})(["&&{margin-inline-end:", ";}"], spacing2x);
var FolderCard = /*#__PURE__*/React.forwardRef(function FolderCard2(props, ref) {
  var _props$actions = props.actions,
    actions = _props$actions === void 0 ? [] : _props$actions,
    buttonMenuProps = props.buttonMenuProps,
    checkboxProps = props.checkboxProps,
    titleProps = props.titleProps,
    rest = _objectWithoutProperties(props, _excluded);
  var selectable = !isEmpty(checkboxProps);
  var isSelected = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.checked;
  return /*#__PURE__*/jsxs(StyledCardContainer, _objectSpread(_objectSpread({
    ref: ref,
    selected: isSelected
  }, rest), {}, {
    children: [selectable && /*#__PURE__*/jsx(StyledCheckbox, _objectSpread({}, checkboxProps)), /*#__PURE__*/jsx(CardTitle, _objectSpread({}, titleProps)), /*#__PURE__*/jsxs(CardActions, {
      children: [actions.length ? React.Children.map(actions, function (child) {
        return /*#__PURE__*/jsx("div", {
          children: child
        });
      }) : null, buttonMenuProps && /*#__PURE__*/jsx(ButtonMenu, _objectSpread(_objectSpread({}, buttonMenuProps), {}, {
        buttonProps: _objectSpread({
          hideLabel: true,
          startAdornment: IconMore,
          variant: "ghost"
        }, buttonMenuProps === null || buttonMenuProps === void 0 ? void 0 : buttonMenuProps.buttonProps)
      }))]
    })]
  }));
});
FolderCard.displayName = "FolderCard";

export { FolderCard };
